import { useSelector } from 'react-redux';
import { getProfile } from '../../config/global';

function AvatarCircle({ className = '', style = {}, onClick }) {
    const logo = useSelector(s => s.global.companyDetails?.company?.logo);
    const name = getProfile().name || '';
    const initials = name.split(' ').filter(Boolean).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';

    if (logo) {
        return (
            <img
                src={logo}
                alt=""
                className={className}
                style={{ objectFit: 'contain', ...style }}
                onClick={onClick}
            />
        );
    }
    return (
        <div
            className={className}
            style={{
                // Was raw indigo #696cff — repointed to the honey/coral
                // gradient (shell migration, .claude/pp-shell-prototype.html
                // .user .av). Shared beyond the sidebar (also Layout/
                // Profile.jsx), so this is a real cross-page color change,
                // not just this route.
                background: 'linear-gradient(140deg, var(--pp-btn-honey), var(--pp-btn-coral))',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600,
                borderRadius: '50%',
                fontSize: '0.875rem',
                flexShrink: 0,
                userSelect: 'none',
                ...style,
            }}
            onClick={onClick}
        >
            {initials}
        </div>
    );
}

export default AvatarCircle;
